// src/components/apps/common/MouseSpeed.js
import * as React from 'react';

import Box from '@mui/material/Box'
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// i18n
import { useI18n } from '../../../i18n/I18nContext';

const UNSET_TEMP = -9999;

export default function MouseSpeed(props) {
  const { value, onChange, onChangeCommitted } = props;

  const [tempValue, setTempValue] = React.useState(UNSET_TEMP);
  const { t } = useI18n();

  return (
    <>
      <Typography sx={{ ml: 1.5, mt: 1.5 }} id="input-slider" gutterBottom>
        {t('mouseSpeedLabel')}
      </Typography>

      <Stack
        spacing={2}
        direction="row"
        sx={{ width: '50ch', maxWidth: '100%', ml: 1.5, mb: .5 }}
      >
        <Box sx={{ width: '100%' }}>
          <Slider
            valueLabelDisplay="auto"
            min={-5} max={5} step={1}
            marks={[{ value: 0, label: t('mouseSpeedDefault') }]}
            value={tempValue !== UNSET_TEMP ? tempValue : value}
            onChange={(e, val) => { onChange(e, val); setTempValue(val); }}
            onChangeCommitted={(e, val) => { onChangeCommitted(e, val); setTempValue(UNSET_TEMP); }}
          />
        </Box>
      </Stack>
    </>
  );
}